import { getLetterByIndex } from '@shared/utils/common';
import { Cargo } from '../../types/cargo';
import { PointWithLabel } from '../../types/location';

export function getCargoRoutePoints(cargo: Cargo) {
  let globalIndex = 0;

  const rawLoad = cargo.loadingAddressesJson.map(a => {
    const item = {
      coords: [Number(a.latitude), Number(a.longitude)] as [number, number],
      label: getLetterByIndex(globalIndex, true),
      isValid: !!(a.latitude && a.longitude),
    };
    globalIndex++;
    return item;
  });

  const rawTransit = cargo.transitPointsJson.map(point => {
    const item = {
      coords: [
        Number(point.transitPoint.latitude),
        Number(point.transitPoint.longitude),
      ] as [number, number],
      label: getLetterByIndex(globalIndex, true),
      displayOnRoute: point.displayOnRoute,
      isValid: !!(point.transitPoint.latitude && point.transitPoint.longitude),
    };
    globalIndex++;
    return item;
  });

  const rawUnload = cargo.unloadingAddressesJson.map(a => {
    const item = {
      coords: [Number(a.latitude), Number(a.longitude)] as [number, number],
      label: getLetterByIndex(globalIndex, true),
      approximateLocation: a.approximateLocation,
      isValid: !!(a.latitude && a.longitude),
    };
    globalIndex++;
    return item;
  });

  const toPoint = (p: {
    coords: [number, number];
    label: string;
  }): PointWithLabel => ({
    coords: p.coords,
    label: p.label,
  });

  const allPoints: PointWithLabel[] = [
    ...rawLoad.map(toPoint),
    ...rawTransit.map(toPoint),
    ...rawUnload.map(toPoint),
  ];

  const validPoints: PointWithLabel[] = [
    ...rawLoad.filter(p => p.isValid).map(toPoint),
    ...rawTransit.filter(p => p.isValid && !!p.displayOnRoute).map(toPoint),
    ...rawUnload.filter(p => p.isValid && !p.approximateLocation).map(toPoint),
  ];

  return { allPoints, validPoints };
}

export function getCargoRoutePointsWithContent(cargo: Cargo) {
  const validPoints: Array<{ lat: number; lng: number; content: string }> = [];
  cargo.loadingAddressesJson.forEach(a => {
    if (a.latitude && a.longitude) {
      validPoints.push({
        lat: Number(a.latitude),
        lng: Number(a.longitude),
        content: [a.farmName, a.address, a.comment].join('\n'),
      });
    }
  });
  cargo.transitPointsJson
    .filter(point => !!point.displayOnRoute)
    .forEach(point => {
      if (point.transitPoint.latitude && point.transitPoint.longitude) {
        validPoints.push({
          lat: Number(point.transitPoint.latitude),
          lng: Number(point.transitPoint.longitude),
          content: [point.transitPoint.name, point.transitPoint.address].join(
            '\n',
          ),
        });
      }
    });
  cargo.unloadingAddressesJson.forEach(a => {
    if (a.latitude && a.longitude) {
      const isApproximate = a.approximateLocation
        ? '<b class="text-red-500">УСЛОВНО!</b>'
        : '';
      validPoints.push({
        lat: Number(a.latitude),
        lng: Number(a.longitude),
        content: [a.clientName, a.address, isApproximate].join('\n'),
      });
    }
  });

  return { validPoints };
}
